import { useEffect, useMemo, useRef } from "react";
import { useChat } from "../hooks/useChatData";
import ExportButtons from "./ExportButtons";
import Markdown from "./Markdown";
import PendingAnswer from "./PendingAnswer";

export default function MessagesPane({ chatId }) {
  const { data, isLoading } = useChat(chatId);
  const bottomRef = useRef(null);

  const messages = useMemo(() => {
    if (!data) return [];
    return Array.isArray(data?.messages) ? data.messages : [];
  }, [data]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages?.length]);

  if (!chatId) {
    return (
      <div className="ia-messages__empty">Selecione ou inicie uma conversa</div>
    );
  }

  if (isLoading) {
    return <div className="ia-messages__hint">Carregando mensagens…</div>;
  }

  return (
    <div className="ia-messages">
      {messages.map((m) => {
        const isUser = m.role === "user";
        const isAssistant = !isUser;
        const isStreaming = isAssistant && m?.status === "pending";
        const hasText = isAssistant && !!m?.content?.length;

        return (
          <div
            key={m.id}
            className={`ia-bubble ia-bubble--${isUser ? "user" : "assistant"}`}
          >
            {isUser ? (
              <div className="ia-bubble__content">{m.content || ""}</div>
            ) : (
              <div className="ia-bubble__content">
                {hasText && <Markdown>{m.content}</Markdown>}
                {isStreaming && (
                  <PendingAnswer variant={hasText ? "inline" : "block"} />
                )}
                {hasText && !isStreaming && (
                  <ExportButtons content={m.content} messageId={m.id} />
                )}
              </div>
            )}
          </div>
        );
      })}
      <div ref={bottomRef} />
    </div>
  );
}
